import { useRouter } from 'expo-router'
import type { ReactNode } from 'react'
import { View } from 'react-native'

import { useUserQuery } from '@/src/features/user/services/useUserQuery'
import { useRoutes } from '@/src/general/utils/routes'

import { useConversationsPreviewQuery } from '../../services/useConversationsPreviewQuery'
import { useCreateConversationMutation } from '../../services/useCreateConversationMutation'
import { ConversationFooter } from './ConversationFooter'

type TFirstConversationProps = {
  conversation?: never
  userId: number
  conversationId: number | undefined
}

export const FirstConversation = ({ userId, conversationId }: TFirstConversationProps): ReactNode => {
  const router = useRouter()
  const { routes } = useRoutes()
  const { data: user } = useUserQuery(userId)
  const createConversationMutation = useCreateConversationMutation(userId)
  const { addInConversationPreview } = useConversationsPreviewQuery()

  return (
    <View className="flex-1 justify-end">
      <ConversationFooter
        newMessageMutation={createConversationMutation}
        onMessageCreated={(message) => {
          if (user) {
            addInConversationPreview(message, user)
          }
          router.replace(routes.conversationById(message.conversationId))
        }}
        userId={userId}
        conversationId={conversationId}
      />
    </View>
  )
}
